<template>
  <div class="join-party">
    <div class="header">
      <img src="@/assets/index/dp-lc-bg.png" alt />
      <button @click="goBack">返回上级</button>
    </div>
    <div class="content">
      <div class="template-box" v-for="data in datas" :key="data.title">
        <p class="title" v-text="data.title" :class="data.state=='完成'?'':'gray'"></p>
        <div class="template-list">
          <div class="template-msg" v-for="msg in data.msgs" :key="msg.title">
            <img :src="msg.state!='当前状态：暂未到此流程'?imgFinish:imgUnderway" alt />
            <div class="ptext">
              <p v-text="msg.title" :class="msg.state!='当前状态：暂未到此流程'?'':'grays'"></p>
              <p v-text="msg.state" :class="msg.state!='当前状态：暂未到此流程'?'':'grays'"></p>
            </div>
            <button
              :class="msg.state!='当前状态：暂未到此流程'?'':'butgrays'"
              @click="goFlow(msg.title,msg.state)"
            >立即查看</button>
          </div>
        </div>
      </div>
    </div>

    <div class="motai" v-if="motai">
      <div class="msg">
        <img src="@/assets/index/joinParty/success.png" alt />
        <button @click="goBack">我知道了</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: [
        {
          title: "一、申请入党",
          state: "完成",
          msgs: [
            { title: "01 提交入党申请书", state: "当前状态:暂未开始流程" },
            { title: "02党组织派人谈话", state: "当前状态：暂未到此流程" }
          ]
        },

        {
          title: "二、入党积极分子的确定和指定培养",
          state: "完成",
          msgs: [
            {
              title: "03推荐和确定入党积极分子",
              state: "当前状态：暂未到此流程"
            },
            { title: "04上级党委备案", state: "当前状态：暂未到此流程" },
            { title: "05指定培养联系人", state: "当前状态：暂未到此流程" },
            { title: "06培养教育考察", state: "当前状态：暂未到此流程" }
          ]
        },

        {
          title: "三、发展对象的确定和考察",
          state: "完成",
          msgs: [
            { title: "07确定发展对象", state: "当前状态：暂未到此流程" },
            { title: "08报上级党委备案", state: "当前状态：暂未到此流程" },
            { title: "09 确定入党介绍人", state: "当前状态：暂未到此流程" },
            { title: "10 进行政治审查", state: "当前状态：暂未到此流程" },
            { title: "11 开展集中培训", state: "当前状态：暂未到此流程" }
          ]
        },

        {
          title: "四、预备党员接收",
          state: "完成",

          msgs: [
            { title: "12支部委员会审查", state: "当前状态：暂未到此流程" },
            { title: "13上级党委预审", state: "当前状态：暂未到此流程" },
            { title: "14填写入党志愿书", state: "当前状态：暂未到此流程" },
            { title: "15支部讨论大会", state: "当前状态：暂未到此流程" },
            { title: "16上级党委派人谈话", state: "当前状态：暂未到此流程" },
            { title: "17上级党委审批", state: "当前状态：暂未到此流程" },
            { title: "18上级党委组织部备案", state: "当前状态：暂未到此流程" }
          ]
        },

        {
          title: "五、预备党员的教育考察和转正",
          state: "完成",
          msgs: [
            { title: "19编入党支部党小组", state: "当前状态：暂未到此流程" },
            { title: "20入党宣誓", state: "当前状态：暂未到此流程" },
            { title: "21继续教育考察", state: "当前状态：暂未到此流程" },
            { title: "22提出转正申请", state: "当前状态：暂未到此流程" },
            { title: "23支部讨论大会", state: "当前状态：暂未到此流程" },
            { title: "24上级党委审批", state: "当前状态：暂未到此流程" },
            { title: "25材料归档", state: "当前状态：暂未到此流程" }
          ]
        }
      ],
      imgFinish: require("@/assets/index/dp-lc-sy2.png"),
      imgUnderway: require("@/assets/index/dp-lc-sy1.png"),
      motai:false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goFlow(value, state) {
      if (state == "当前状态：暂未到此流程") return;
      this.$router.push({
        path: "/index/joinparty/joinpartyflow",
        query: { title: value, name: Number(value.slice(0, 2) - 1) }
      });
    },
    getMsg() {
      this.axios
        .get(`/api/Index/GetState?userid=${sessionStorage.getItem("id")}`)
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              let changeState = (number, maxnum) => {
                for (let x = 0; x < maxnum; x++) {
                  this.datas[number].msgs[x].state = "当前状态:该流程已完成";
                }
              };
              let tempNum = e.data.msg;
              if (tempNum < 3) {
                //第一行是判断颜色, tempNum - 0  0指代的是第0排没有数据
                changeState(0, tempNum - 0);
                this.datas[0].msgs[tempNum - 1].state='当前状态:流程正在进行中';

              } else if (tempNum > 2 && tempNum < 7) {
                //第一行是判断颜色, tempNum - 2  2指代的是第1排有两个数据
                changeState(0, 2);
                changeState(1, tempNum - 2);
                this.datas[1].msgs[tempNum - 3].state='当前状态:流程正在进行中';

              } else if (tempNum > 6 && tempNum < 12) {
                changeState(0, 2);
                changeState(1, 4);
                changeState(2, tempNum - 6);
                this.datas[2].msgs[tempNum - 7].state='当前状态:流程正在进行中';

              } else if (tempNum > 11 && tempNum < 19) {
                changeState(0, 2);
                changeState(1, 4);
                changeState(2, 5);
                changeState(3, tempNum - 11);
                //这一行的意思 12 的意思是 刚好到了这个流程就暂停
                this.datas[3].msgs[tempNum - 12].state='当前状态:流程正在进行中';
              } else if (tempNum > 18 && tempNum < 26) {
                changeState(0, 2);
                changeState(1, 4);
                changeState(2, 5);
                changeState(3, 7);
                changeState(4, tempNum - 18);
                this.datas[4].msgs[tempNum - 19].state='当前状态:流程正在进行中';

              }else{
                this.motai = true;
              }

              break;

            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getBranchId(){
      this.axios.get(
        `/api/Index/GetBranchID?userid=${sessionStorage.getItem('id')}`
      ).then(e=>{
        if(e.data.code==0){
          sessionStorage.setItem('tempBranchId',e.data.msg[0].BranchID)
        }
      })
    }
  },
  mounted() {
    this.getMsg();
    this.getBranchId();
  }
};
</script>
<style lang='scss' scoped>
.join-party {
  .motai {
    .msg {
      button {
        position: absolute;
        bottom: .8rem;
        border: none;
        background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
        color: #fff;
        font-size: 0.28rem;
        left: 25%;
        padding: 0.2rem 1.15rem;
        border-radius: .5rem
      }
      img {
        width: 100%;
      }
      width: 90%;
      margin: 15vh auto;
      position: relative;
    }
    width: 100%;
    position: fixed;
    top: 0;
    background: rgba($color: #000000, $alpha: 0.2);
    height: 100vh;
    z-index: 8;
  }

  .content {
    .template-box {
      &:nth-child(2) {
        .template-list {
          .template-msg {
            &:nth-child(1) {
              .ptext {
                p {
                  &:nth-child(1) {
                    font-size: 0.25rem !important;
                  }
                }
              }
            }
          }
        }
      }
      .gray {
        background: #cccccc !important;
      }
      .template-list {
        .grays {
          color: #999998 !important;
        }
        .butgrays {
          background: #cccccc !important;
        }
        .template-msg {
          &:nth-child(even) {
            margin-left: 2%;
          }
          button {
            padding: 0.1rem 0.2rem;
            position: absolute;
            bottom: 0.3rem;
            left: 0.21rem;
            background-color: #ea5e63;
            border-radius: 0.22rem;
            border: 0;
            padding: 0.05rem 0.2rem;
            color: #fff;
            font-size: 0.3rem;
          }
          .ptext {
            p {
              &:nth-child(1) {
                font-size: 0.29rem;
                font-weight: bold;
                color: #ea5e63;
                line-height: 2;
              }
              &:nth-child(2) {
                font-size: 0.24rem;
                line-height: 2;
              }
            }
            position: absolute;
            top: 0.3rem;
            left: 0.2rem;
          }
          img {
            width: 100%;
            height: 2.6rem;
          }
          position: relative;
        }

        margin-top: 0.3rem;
        display: grid;
        grid-template-columns: 49% 49%;
        grid-template-rows: auto 1fr;
      }
      .title {
        color: #fff;
        display: inline-block;
        background: #ea5e63;
        border-radius: 0.3rem;
        padding: 0.1rem 0.3rem;
      }
      width: 94%;
      margin: 0 auto;
    }
    top: 4.32rem;
    position: absolute;
    width: 100%;
    background: #fff2df;
    z-index: 7;
  }
  .header {
    button {
      padding: 0.1rem 0.2rem;
      color: #ffffff;
      font-size: 0.32rem;
      background-image: linear-gradient(90deg, #fb8d72 0%, #ea5e63 100%);
      border-radius: 0.04rem;
      border: 0;
      position: absolute;
      right: 0.5rem;
      top: 0.7rem;
    }
    img {
      width: 100%;
    }
    position: relative;
    z-index: 8;
  }
  font-size: 0.3rem;
}
</style>

